import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import {
  Row,
  Code, CodeInput,
} from './Styles';

const PickupCode: FC<Props> = ({
  style,
  callback,
}) => {

  const code1Ref = useRef<HTMLInputElement>(null);
  const code2Ref = useRef<HTMLInputElement>(null);
  const code3Ref = useRef<HTMLInputElement>(null);
  const code4Ref = useRef<HTMLInputElement>(null);

  const [code1, setCode1] = useState<string>();
  const [code2, setCode2] = useState<string>();
  const [code3, setCode3] = useState<string>();
  const [code4, setCode4] = useState<string>();
  const [focusIndex, setFocusIndex] = useState<number>(1);

  useEffect(() => {
    if (focusIndex === 1 && code1Ref.current) {
      code1Ref.current.focus();
    }
    if (focusIndex === 2 && code2Ref.current) {
      code2Ref.current.focus();
    }
    if (focusIndex === 3 && code3Ref.current) {
      code3Ref.current.focus();
    }
    if (focusIndex === 4 && code4Ref.current) {
      code4Ref.current.focus();
    }
  }, [focusIndex]);

  useEffect(() => {
    if (code1 && code2 && code3 && code4) {
      callback(code1 + code2 + code3 + code4);
    }
  }, [code1, code2, code3, code4]);

  return (
    <>
      {/* 取餐码 */}
      <Row style={{ justifyContent: 'space-between', ...style }}>
        <Code>
          <CodeInput
            type="number"
            maxLength={1}
            value={code1}
            ref={code1Ref}
            autoFocus={true}
            onFocus={() => {
              setFocusIndex(1);
            }}
            onKeyUp={(e) => {
              // 输入了e时，文本框内容就不受控制了
              if (e.keyCode === 69) {
                setCode1('0');
              }
            }}
            onChange={(e) => {
              const val = e.target.value;
              console.log(val);
              if (/^\d+$/.test(val)) {
                setCode1(val.substring(0, 1));
                setFocusIndex(2);

                if (val.length > 1) {
                  setCode2(val.substring(1, 2));
                  setFocusIndex(3);
                }
              }
              else {
                setCode1('');
              }
            }}
          />
        </Code>
        <Code>
          <CodeInput
            type="number"
            maxLength={1}
            value={code2}
            ref={code2Ref}
            onFocus={() => {
              setFocusIndex(2);
            }}
            onKeyUp={(e) => {
              if (e.keyCode === 8) {
                setFocusIndex(1);
              }
              // 输入了e时，文本框内容就不受控制了
              if (e.keyCode === 69) {
                setCode1('0');
              }
            }}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d+$/.test(val)) {
                setCode2(val.substring(0, 1));
                setFocusIndex(3);

                if (val.length > 1) {
                  setCode3(val.substring(1, 2));
                  setFocusIndex(4);
                }
              }
              else {
                setCode2('');
              }
            }}
          />
        </Code>
        <Code>
          <CodeInput
            type="number"
            maxLength={1}
            value={code3}
            ref={code3Ref}
            onFocus={() => {
              setFocusIndex(3);
            }}
            onKeyUp={(e) => {
              if (e.keyCode === 8) {
                setFocusIndex(2);
              }
              // 输入了e时，文本框内容就不受控制了
              if (e.keyCode === 69) {
                setCode1('0');
              }
            }}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d+$/.test(val)) {
                setCode3(val.substring(0, 1));
                setFocusIndex(4);

                if (val.length > 1) {
                  setCode4(val.substring(1, 2));
                }
              }
              else {
                setCode3('');
              }
            }}
          />
        </Code>
        <Code>
          <CodeInput
            type="number"
            maxLength={1}
            value={code4}
            ref={code4Ref}
            onFocus={() => {
              setFocusIndex(4);
            }}
            onKeyUp={(e) => {
              if (e.keyCode === 8) {
                setFocusIndex(3);
              }
              // 输入了e时，文本框内容就不受控制了
              if (e.keyCode === 69) {
                setCode1('0');
              }
            }}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d+$/.test(val)) {
                setCode4(val.substring(0, 1));
              }
              else {
                setCode4('');
              }
            }}
          />
        </Code>
      </Row>
    </>
  );
};

export interface Props {
  style?: React.CSSProperties;
  callback: (code: string) => void;
}

export default PickupCode;
